import HourglassTopIcon from '@mui/icons-material/HourglassTop'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const WaitingPage = () => {
  const { t } = useTranslation('impact/WaitingPage')
  const { palette } = useTheme()
  return (
    <Stack alignItems="center" height="100%" mb={15} justifyContent="center">
      <Stack spacing={1.5} alignItems="center">
        <Stack spacing={4} alignItems="center">
          <Box
            sx={{
              background: palette.warning.main,
              color: palette.warning.contrastText,
              height: '48px',
              width: '48px',
              textAlign: 'center',
              paddingTop: '12px',
              borderRadius: '50%',
            }}
          >
            <HourglassTopIcon />
          </Box>
          <Typography variant="caption" sx={{ textTransform: 'uppercase' }}>
            {t('waiting')}
          </Typography>
        </Stack>
        <Typography variant="h6">{t('calculatingTitle')}</Typography>
        <Typography variant="body1">{t('calculatingSubtitle')}</Typography>
      </Stack>
    </Stack>
  )
}
